import React, { Component } from 'react';
import BaseGantt from '@/components/BaseGantt';
import { Spin } from 'antd';
import './index.scss';
import dayjs from 'dayjs';
import { getProjectStep } from '@/api/personCenter/decorationManage';
export default class ConstructionSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                overview: {},
                list: [],
                loading: false,
            },
        };
    }

    componentDidMount() {
        this.setState({ loading: true });
        getProjectStep({ projectVId: this.props.projectId, div: 2 })
            .then(({ data, msg, code }) => {
                if (code !== 0) {
                    this.setState({ loading: false });
                    throw msg;
                }
                this.setState({ data, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
                throw err;
            });
    }

    initColumns = () => {
        let ret = [
            {
                name: 'name',
                label: '施工项目',
                resize: true,
                align: 'center',
            },
            { name: 'start_date', label: '开始时间', align: 'center' },
        ];
        return ret;
    };

    initSummary = () => {
        let { overview } = this.state.data;
        if (!overview) return null;
        let data = [
            { count: overview.total, title: '施工项目总数' },
            { count: overview.planDay, title: '整体进度' },
            {
                count: overview.delay,
                title: '延期项目数',
                key: 'delayItemNums',
            },
            { count: overview.delayDay, title: '延期天数', key: 'delayDays' },
            { count: overview.backwardsDay, title: '施工倒计时' },
        ];

        return data.map(({ count, title, key }, index) => {
            let tmpStyle = {
                color:
                    (key === 'delayItemNums' || key === 'delayDays') &&
                    count > 0
                        ? 'red'
                        : 'blank',
            };

            return (
                <div key={index} className="summary-item">
                    <div className="summary-count" style={tmpStyle}>
                        {count}
                    </div>
                    <div className="summary-title">{title}</div>
                </div>
            );
        });
    };

    initStatus = () => {
        let data = [
            { color: '#52C41A', title: '已完成' },
            { color: '#DF773C', title: '进行中' },
            { color: '#FF4D4F', title: '延期' },
            { color: 'rgba(40, 47, 85, 0.3)', title: '未开始' },
        ];

        return data.map(({ color, title }, index) => {
            let tmpStyle = {
                borderColor: color,
            };
            return (
                <div className="status-item" key={index}>
                    <span className="status-flag" style={tmpStyle}></span>
                    <span className="status-title">{title}</span>
                </div>
            );
        });
    };

    get realData() {
        // 加进度条以及后期数据转换
        const res = this.state?.data.list?.map(e => {
            return {
                ...e,
                start_date: dayjs(e.startTime).toDate(),
                end_date: dayjs(e.endTime).toDate(),
                curProcess:
                    +e.status === 3 ? 0 : +e.status === 1 ? -1 : e.finishDay,
                period: e.allDay,
                timeLeft: e.allDay - e.finishDay,
                postponementTime: +e.deferTime,
                progress: e.finishDay / (e.allDay + e.deferTime),
            };
        });
        return res;
    }

    render() {
        if (!this.realData) return null;
        return (
            <Spin spinning={this.state.loading}>
                <div className="construction-schedule">
                    <div className="state-row">
                        <div style={{ display: 'flex' }}>
                            {this.initSummary()}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {this.initStatus()}
                        </div>
                    </div>
                    <BaseGantt
                        tasks={this.realData}
                        columns={this.initColumns()}
                    />
                    {/* <Pagination
                        size="small"
                        defaultCurrent={1}
                        total={this.state.data.list.length}
                        showSizeChanger={false}
                        showTotal={total => `${total}条`}
                    /> */}
                </div>
            </Spin>
        );
    }
}
